
import FileSaver from "file-saver";
import XLSX from "xlsx";

const print = {
  print_dom_id (id, title) {
    //表格导出
    let fix = document.querySelector(".el-table__fixed");
    let wb;
    var xlsxParam = {
      raw: true,
    }; //转换成excel时，使用原始的格式
    if (fix) {
      //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
      wb = XLSX.utils.table_to_book(
        document.querySelector("#" + id).removeChild(fix),
        xlsxParam
      );
      document.querySelector("#" + id).appendChild(fix);
    } else {
      wb = XLSX.utils.table_to_book(
        document.querySelector("#" + id),
        xlsxParam
      );
    }
    let result = XLSX.utils.sheet_to_json(wb.Sheets.Sheet1, { header: 1 });
    var iframe = document.createElement("IFRAME");
    var doc = null;
    /* 调试表格样式 */
    iframe.setAttribute(
      "style",
      "position:absolute;width:794px;height:0px;left:-749px;top:0px;"
    );
    document.body.appendChild(iframe);
    /* 获取网页标题 */
    var titleText = document.head.getElementsByTagName("title")[0].innerText;
    /* 设置网页标题为传入的标题 */
    document.head.getElementsByTagName("title")[0].innerText = `${title}`;
    doc = iframe.contentWindow.document;



    let colunmCount = 0;
    let topTr = ""

    //当前的table的索引
    let tableIndex = -1
    //当前总需要table的个数
    let tableCount = 0

    for (let i = 0; i < result.length; i++) {
      //拿到第一行的列数
      if (i == 0) {
        colunmCount = result[i].length
      }

      let tr = ""
      if (tableCount !== tableIndex) {
        doc.write(`<div class='page'><table class="gridtable"><tbody>${topTr}</tbody></table></div>`)
        tableIndex++;
      }
      tr += "<tr>";
      let tds = "";
      const resultData = result[i];
      for (let k = 0; k < resultData.length; k++) {
        const value = resultData[k];
        tds += `<td>${value ? value : ""}</td>`;
      }

      //当列数不满足第一行的列数时，补足列数，保持表格一致
      for (let c = 0; c < colunmCount - resultData.length; c++) {
        tds += `<td></td>`;
      }
      tr += tds;
      tr += "</tr>";
      //保存头部内容
      if (i === 0) {
        topTr = tr
      }
      let bodystr = iframe.contentWindow.document.querySelectorAll(".gridtable")[tableIndex].querySelector("tbody").innerHTML;
      bodystr += tr
      iframe.contentWindow.document.querySelectorAll(".gridtable")[tableIndex].querySelector("tbody").innerHTML = bodystr;
      let tableHeight = iframe.contentWindow.document.querySelectorAll(".gridtable")[tableIndex].offsetHeight
      if (tableHeight > 900) {
        doc.write(`<div class="pageBreak" style="page-break-after: always" ></div>`)
        tableCount++;
      }
    }
    doc.write(`
        <style media="print">
	    @page {
	      size: auto;  /* auto is the initial value */
	      margin: 0mm 0mm; /* this affects the margin in the printer settings */
	    }
	</style>
        <style type="text/css">
        body{
            margin:0px;
            padding:0px;
        }
        .page{
            padding:10px;
            box-sizing: border-box;
            width:100%;
            height:1100px;
            overflow: hidden;
        }
.gridtable{
  width: 100%;
}
table.gridtable {
     font-family: verdana,arial,sans-serif;
    font-size:11px;
    color:#333333;
   border-width: 1px;
    border-color: #666666;
    border-collapse: collapse;
}
table.gridtable th {
   border-width: 1px;
    padding: 8px;
    border-style: solid;
   border-color: #666666;
    background-color: #dedede;
}
table.gridtable td {
   border-width: 1px;
    padding: 8px;
   border-style: solid;
   border-color: #666666;
    background-color: #ffffff;
}</style>`);
    // doc.write("<div>" + domstr + "</div>");
    // doc.write("<div>" +"<div style='font-size:20px;text-align:center'>"+title+"</div>"+ domstr + "</div>");
    doc.close();

    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    document.body.removeChild(iframe);
    document.head.getElementsByTagName("title")[0].innerText = titleText;
  }
}


export default print;